import React, { useState, useEffect } from "react";
import axios from "axios";
import { Row, Col, Button, Card, Input, notification, Modal, Popconfirm, Tag } from "antd";
import { EditOutlined, DeleteOutlined, LinkOutlined, PlusOutlined, SettingOutlined } from "@ant-design/icons";
import { backendURL } from "../Globals";
import Cookies from "js-cookie";

const ACCENT_COLORS = ["#007398", "#2e7d32", "#b45309", "#6d28d9", "#b91c1c", "#1565c0", "#00695c", "#c2185b"];

const DashboardComponent = () => {
    const [dashboards, setDashboards] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showAdminPanel, setShowAdminPanel] = useState(false);
    const [newDashboard, setNewDashboard] = useState({ nombre_editor: "", url_dashboard: "" });
    const [editModal, setEditModal] = useState({ open: false, nombre_editor: "", url_dashboard: "" });

    useEffect(() => {
        fetchDashboards();
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        setIsLoggedIn(!!apiKey);
    }, []);

    // 🔹 Obtener dashboards de la BD
    const fetchDashboards = async () => {
        try {
            const response = await axios.get(`${backendURL}/dashboards`);
            setDashboards(response.data);
        } catch (error) {
            console.error("Error fetching dashboards:", error);
            notification.error({ message: "Error al obtener los dashboards" });
        }
    };

    const handleAddDashboard = async () => {
      const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
      if (!apiKey) {
          notification.error({ message: "No estás autenticado" });
          return;
      }
  
      // 🔹 Verificar que los valores existen antes de aplicar `.trim()`
      const nombreEditor = newDashboard.nombre_editor ? newDashboard.nombre_editor.trim() : "";
      const urlDashboard = newDashboard.url_dashboard ? newDashboard.url_dashboard.trim() : "";
  
      if (!nombreEditor || !urlDashboard) {
          notification.error({ message: "Debes completar todos los campos" });
          return;
      }
  
      const payload = {
          nombre_editor: nombreEditor,
          url_dashboard: urlDashboard,
          logo_editor: newDashboard.logo_editor || "" // Logo opcional
      };
  
      console.log("🔹 Enviando datos al backend:", payload);
  
      try {
          const response = await axios.post(`${backendURL}/dashboards`, payload, {
              headers: { 
                  Authorization: `Bearer ${apiKey}`,
                  "Content-Type": "application/json"
              }
          });
  
          console.log("✅ Respuesta del servidor:", response.data);
  
          if (response.data.success) {
              setDashboards([...dashboards, response.data.dashboard]);
              setNewDashboard({ nombre_editor: "", url_dashboard: "", logo_editor: "" });
  
              // 🔹 Mostrar mensaje de éxito
              notification.success({
                  message: "✅ Editor añadido correctamente",
                  description: `El editor ${nombreEditor} se ha agregado con éxito.`
              });
          } else {
              notification.error({ message: response.data.error || "⚠️ Error al añadir el editor" });
          }
      } catch (error) {
          console.error("❌ Error al añadir el editor:", error.response?.data || error);
          notification.error({ message: "⚠️ Error al añadir el editor" });
      }
  };
  
  

    // 🔹 Eliminar un editor con confirmación
    const handleDeleteDashboard = (nombre_editor) => {
        Modal.confirm({
            title: "¿Estás seguro de eliminar este editor?",
            content: `Esta acción no se puede deshacer. Eliminarás el dashboard de ${nombre_editor}.`,
            okText: "Sí, eliminar",
            okType: "danger",
            cancelText: "Cancelar",
            onOk: async () => {
                const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
                if (!apiKey) {
                    notification.error({ message: "No estás autenticado" });
                    return;
                }

                try {
                    await axios.delete(`${backendURL}/dashboards/${encodeURIComponent(nombre_editor)}`, {
                        headers: { Authorization: `Bearer ${apiKey}` }
                    });

                    setDashboards(dashboards.filter(dash => dash.nombre_editor !== nombre_editor));
                    notification.success({ message: "Editor eliminado correctamente" });
                } catch (error) {
                    console.error("Error deleting dashboard:", error);
                    notification.error({ message: "Error al eliminar el editor" });
                }
            }
        });
    };

    const handleEditUrl = async () => {
        const { nombre_editor, url_dashboard } = editModal;
        if (!url_dashboard.trim()) {
            notification.error({ message: "La URL no puede estar vacía" });
            return;
        }
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        try {
            await axios.put(`${backendURL}/dashboards/${encodeURIComponent(nombre_editor)}`,
                { url_dashboard: url_dashboard.trim() },
                { headers: { Authorization: `Bearer ${apiKey}` } }
            );
            setDashboards(dashboards.map(d =>
                d.nombre_editor === nombre_editor ? { ...d, url_dashboard: url_dashboard.trim() } : d
            ));
            setEditModal({ open: false, nombre_editor: "", url_dashboard: "" });
            notification.success({ message: "URL actualizada correctamente" });
        } catch (error) {
            notification.error({ message: "Error al actualizar la URL" });
        }
    };

    return (
        <div style={{ padding: "32px 24px", maxWidth: 960, margin: "0 auto" }}>
            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24, color: "#1a1a2e" }}>
                Dashboards de Editores
            </h2>

            <Row gutter={[24, 24]}>
                {dashboards.map((dash, idx) => {
                    const accent = ACCENT_COLORS[idx % ACCENT_COLORS.length];
                    return (
                        <Col key={dash.nombre_editor} xs={24} md={12}>
                            <Card
                                hoverable
                                bordered={false}
                                style={{
                                    borderRadius: 14,
                                    boxShadow: "0 2px 16px rgba(0,0,0,0.09)",
                                    borderTop: `4px solid ${accent}`,
                                    height: "100%",
                                }}
                                actions={isLoggedIn && showAdminPanel ? [
                                    <EditOutlined
                                        key="edit"
                                        style={{ color: "#007398", fontSize: 16 }}
                                        title="Editar URL"
                                        onClick={() => setEditModal({ open: true, nombre_editor: dash.nombre_editor, url_dashboard: dash.url_dashboard })}
                                    />,
                                    <Popconfirm
                                        key="delete"
                                        title={`¿Eliminar el dashboard de ${dash.nombre_editor}?`}
                                        okText="Sí, eliminar"
                                        okType="danger"
                                        cancelText="Cancelar"
                                        onConfirm={() => handleDeleteDashboard(dash.nombre_editor)}
                                    >
                                        <DeleteOutlined style={{ color: "#ff4d4f", fontSize: 16 }} />
                                    </Popconfirm>
                                ] : undefined}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                                    <div style={{
                                        width: 40, height: 40, borderRadius: 10,
                                        background: accent, display: "flex",
                                        alignItems: "center", justifyContent: "center", flexShrink: 0
                                    }}>
                                        <LinkOutlined style={{ color: "#fff", fontSize: 18 }} />
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: 17, color: "#1a1a2e", lineHeight: 1.2 }}>
                                            {dash.nombre_editor}
                                        </div>
                                        <Tag color="default" style={{ fontSize: 11, marginTop: 4, maxWidth: 240, overflow: "hidden", textOverflow: "ellipsis" }}>
                                            {dash.url_dashboard}
                                        </Tag>
                                    </div>
                                </div>
                                <a href={dash.url_dashboard} target="_blank" rel="noopener noreferrer">
                                    <Button type="primary" block size="large" icon={<LinkOutlined />}
                                        style={{ background: accent, borderColor: accent }}>
                                        Acceder al Dashboard
                                    </Button>
                                </a>
                            </Card>
                        </Col>
                    );
                })}
            </Row>

            {isLoggedIn && (
                <div style={{ textAlign: "center", marginTop: 32 }}>
                    <Button
                        icon={<SettingOutlined />}
                        type={showAdminPanel ? "primary" : "dashed"}
                        onClick={() => setShowAdminPanel(!showAdminPanel)}
                    >
                        {showAdminPanel ? "Ocultar administración" : "Administrar Dashboards"}
                    </Button>
                </div>
            )}

            {isLoggedIn && showAdminPanel && (
                <Card
                    style={{ marginTop: 24, maxWidth: 480, marginLeft: "auto", marginRight: "auto", borderRadius: 12 }}
                    title={<span><PlusOutlined /> Añadir nuevo editor</span>}
                >
                    <Input
                        placeholder="Nombre del Editor"
                        value={newDashboard.nombre_editor}
                        onChange={e => setNewDashboard({ ...newDashboard, nombre_editor: e.target.value })}
                        style={{ marginBottom: 12 }}
                        size="large"
                    />
                    <Input
                        placeholder="URL del Dashboard"
                        value={newDashboard.url_dashboard}
                        onChange={e => setNewDashboard({ ...newDashboard, url_dashboard: e.target.value })}
                        style={{ marginBottom: 16 }}
                        size="large"
                    />
                    <Button type="primary" onClick={handleAddDashboard} block size="large" icon={<PlusOutlined />}>
                        Añadir Editor
                    </Button>
                </Card>
            )}

            <Modal
                title={<span><EditOutlined /> Editar URL — {editModal.nombre_editor}</span>}
                open={editModal.open}
                onOk={handleEditUrl}
                onCancel={() => setEditModal({ open: false, nombre_editor: "", url_dashboard: "" })}
                okText="Guardar"
                cancelText="Cancelar"
            >
                <Input
                    size="large"
                    placeholder="Nueva URL del Dashboard"
                    value={editModal.url_dashboard}
                    onChange={e => setEditModal({ ...editModal, url_dashboard: e.target.value })}
                    style={{ marginTop: 8 }}
                />
            </Modal>
        </div>
    );
};

export default DashboardComponent;
